import { render, staticRenderFns } from "./LCDPanel.vue?vue&type=template&id=5d6a42c8&scoped=true&"
import script from "./LCDPanel.vue?vue&type=script&lang=js&"
export * from "./LCDPanel.vue?vue&type=script&lang=js&"
import style0 from "./LCDPanel.vue?vue&type=style&index=0&id=5d6a42c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6a42c8",
  null
  
)

export default component.exports